import React from 'react';
import CountUp  from 'react-countup';
// import TransactionIcon from 'react-icons/lib/md/pie-chart';
import NairaIcon from '../../assets/icons/naira (2).png';
import DollarIcon from '../../assets/icons/dollar.png';
// import InvoiceIcon from 'react-icons/lib/md/drafts';
import FlightIcon from 'react-icons/lib/md/flight-takeoff';
import AirportIcon from 'react-icons/lib/md/airplanemode-active';

const FeatureSuccess = () => (
    <div className='section feature-success-container'>
        <div className="container">
            <div className="row">
                <div className="one col-md-6 col-sm-12">
                    <div className="left">
                        <h4 className='mb-4 title text-left text-uppercase fs-title'>
                            Our <br/>Success
                        </h4>
                        <p className="text-left mt-5 description">
                            At AviTech Software Solutions, we value the protection of aviation data. That’s why we build it into our processes right from the start.
                        </p>
                    </div>
                </div>
                <div className={'col-md-12 pt-3 pb-5 pl-2 pr-2'}>
                    <h4 className=''>

                    </h4>
                    <div className="pt-3">

                    </div>
                </div>
            </div>
            <div className="row">
                {/*<div className="col-md-3">*/}
                    {/*<div className={'feature-success-item'}>*/}
                        {/*<h1 className='text-center amount'>*/}
                            {/*<CountUp redraw={true} prefix={'$'} suffix={'mn'} start={0} end={140}/>*/}
                        {/*</h1>*/}
                        {/*<div className="text-center ap-icon">*/}
                            {/*<TransactionIcon color="rgba(225,225,225,.6)" size="100"/>*/}
                        {/*</div>*/}
                        {/*<p className="text-center description">Transactions Processed</p>*/}

                    {/*</div>*/}
                {/*</div>*/}
                <div className="col-md-3">
                    <div className={'feature-success-item'}>
                        <h1 className='text-center amount'>
                            <CountUp start={0} end={22}/>
                        </h1>
                        <div className="text-center ap-icon">
                            <AirportIcon color="rgba(225,225,225,.6)" size="100"/>
                        </div>
                        <p className="text-center description">Total Airports</p>

                    </div>
                </div>
                <div className="col-md-3">
                    <div className={'feature-success-item'}>
                        <h1 className='text-center amount'>
                            <CountUp suffix={'k'} start={0} prefix={'Over '} end={200} />
                        </h1>
                        <div className="text-center ap-icon">
                            <FlightIcon color="rgba(225,225,225,.6)" size="100"/>
                        </div>
                        <p className="text-center description">Flight Data Processed</p>

                    </div>
                </div>
                <div className="col-md-3">
                    <div className={'feature-success-item'}>
                        <h1 className='text-center amount'>
                            <CountUp start={0} end={136} suffix={'MN'} />
                        </h1>
                        <div className="text-center ap-icon">
                        <img src={DollarIcon} alt='dollar-icon' style={{width: "62%"}} />
                        </div>
                        <p className="text-center description">Transactions Processed</p>

                    </div>
                </div>
                <div className="col-md-3">
                <div className={'feature-success-item'}>
                        <h1 className='text-center amount'>
                            <CountUp start={0} end={70} suffix={'BN'} />
                        </h1>
                        <div className="text-center ap-icon">
                            <img src={NairaIcon} alt='dollar-icon' style={{width: "62%"}} />
                        </div>
                        <p className="text-center description">Transactions Processed</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default FeatureSuccess;



// WEBPACK FOOTER //
// ./src/views/home/featured-success.js